/**
 * Auth Layout Component
 * Provides AuthHeader for authentication/onboarding flows using React Router outlet pattern
 */

import { Outlet, useNavigate } from "react-router-dom"
import { ScrollToTop } from "@/components/shared/ScrollToTop"
import { getAssetUrl } from "@/utils/assets"
import { AuthHeader } from "./AuthHeader"

interface AuthLayoutProps {
  children?: React.ReactNode
  showBackButton?: boolean
  enableSmartNavigation?: boolean
  onNavigateBack?: () => void
}
const DEFAULT_AUTH_BACKGROUND = getAssetUrl("auth-bg.jpeg")

export function AuthLayout({
  children,
  showBackButton = true,
  enableSmartNavigation = false,
  onNavigateBack,
}: AuthLayoutProps) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (enableSmartNavigation) {
      // Smart navigation: show logout confirmation
      // This will be handled by AuthHeader's logout logic
    } else if (onNavigateBack) {
      onNavigateBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="relative min-h-screen bg-fill">
      {DEFAULT_AUTH_BACKGROUND && (
        <div
          className="fixed inset-0 bg-cover bg-no-repeat bg-[center_top_-250px] pointer-events-none"
          style={{
            backgroundImage: `url(${DEFAULT_AUTH_BACKGROUND})`,
          }}
        />
      )}
      {DEFAULT_AUTH_BACKGROUND && (
        <div
          className="fixed inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(rgba(2, 2, 2, 0.36) 0%,rgba(2, 2, 2, 0.71) 0% ,#020202 75%)",
          }}
        />
      )}
      <ScrollToTop />
      <AuthHeader
        showBackButton={showBackButton}
        onNavigateBack={handleBack}
        enableSmartNavigation={enableSmartNavigation}
      />
      <div className="relative z-10">{children || <Outlet />}</div>
    </div>
  )
}
